// packages/web-ui/src/api/client.ts
//
// Public re-export surface for the typed API client. Resource-specific helpers
// (chatApi, kbApi, ...) land in their consuming-panel stories; this story ships
// only the foundation.

export { apiCall, apiCallBinary, getDefaultApiContext, TESSA_LEAN_TOKEN_STORAGE_KEY } from './internal/api-call.js';
export type {
  ApiError,
  ApiContext,
  BinaryCallOptions,
  BinaryResult,
} from './internal/api-call.js';

import { getDefaultApiContext } from './internal/api-call.js';
import type { ApiContext } from './internal/api-call.js';

/**
 * Build an {@link ApiContext} from the runtime environment. Reads the bootstrap
 * token from `localStorage` (per epic AC #5) and defaults to a same-origin
 * `baseUrl` so dev (Vite proxy), embed (extension webview), and standalone
 * deployments all work without configuration.
 *
 * @deprecated since MED-4 — prefer `getDefaultApiContext()` (re-exported from
 * the same module). Retained as a thin alias so the 9 pre-existing call-sites
 * outside the MED-4 fix scope keep compiling; a follow-up cleanup story will
 * migrate the remaining callers and drop this name.
 */
export function createApiContext(): ApiContext {
  return getDefaultApiContext();
}
